import React from 'react';

const AllSold = () => {
    return (
        <button className={"btn btn-primary disabled"}>All Sold!</button>
    );

};

export default AllSold;